export default __webpack_public_path__ + "static/media/post-prod.e30cdf66.png";